import crypto from 'crypto';
import Rusha from 'rusha';

export function createMD5String(value) {
  return crypto.createHash('md5').update(value).digest('hex');
}

export function createSha1String(value) {
  return Rusha.createHash().update(value).digest('hex');
}

export function createSha1File(file, { onProgress } = {}) {
  return new Promise((resolve, reject) => {
    const chunkSize = 64000;
    const hash = Rusha.createHash();

    // console.log('Reading file', file.name);

    function readChunk(offset) {
      const reader = new FileReader();

      reader.onload = function (e) {
        if (e.target.error) {
          reject(e.target.error);
        } else {
          hash.update(e.target.result);
          offset += chunkSize;

          if (offset >= file.size) {
            const sha1 = hash.digest('hex');
            // console.log('SHA1', file.name, sha1);
            if (typeof onProgress === 'function') onProgress({ loaded: file.size, total: file.size });
            resolve(sha1);
          } else {
            if (typeof onProgress === 'function') onProgress({ loaded: offset, total: file.size });
            readChunk(offset);
          }
        }
      };

      reader.onerror = () => reject(reader.error);

      reader.readAsArrayBuffer(file.slice(offset, offset + chunkSize));
    }

    readChunk(0);
  });
}



// WEBPACK FOOTER //
// ./src/lib/hashing.js